<template>
  <div
    class="whs-relative-hotels"
    :class="{'is-row': placement === 'mid'}"
    v-show="relativeHotels.length"
  >
    <div class="whs-relative-headline">Посмотрите также</div>
    <div
      class="whs-relative-hotel"
      v-for="hotel in relativeHotels"
      :key="hotel.id"
      @click="proceedToHotel(hotel.id)"
    >
      <div class="whs-relative-image-wrap">
        <transition name="fade">
          <img
            class="whs-relative-image"
            v-if="hotel.info"
            :src="setThumbnail(hotel.info)"
            :alt="hotel.info.name"
            :key="setThumbnail(hotel.info)"
          />
        </transition>
      </div>
      <div class="whs-relative-name">{{ hotel.info.name }}</div>
      <div
        v-if="hotel.rates"
        class="whs-relative-price"
      >{{ toLocalePrice(calcPrice(hotel.rates[0])) }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { calcPrice } from '@/api';

export default {
  name: 'RelativeHotels',
  props: {
    placement: String
  },
  computed: {
    ...mapState('hotels', {
      hotels: state => state.hotels.filter(hotel => hotel.info).slice(0, 5)
    }),
    ...mapState('hero', ['nightsAdults', 'currencyText']),
    ...mapGetters('hero', ['toLocalePrice']),
    relativeHotels() {
      return this.hotels.filter(hotel => hotel.id !== this.$route.params.id);
    }
  },
  methods: {
    setThumbnail(info) {
      if (
        !info.thumbnail ||
        info.thumbnail === 'https://partner.ostrovok.ru/static/img/1px.png'
      )
        return 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
      return info.thumbnail;
    },
    // toLocalePrice(price) {
    //   return `${Math.ceil(price, 10).toLocaleString('ru-Ru')} ${
    //     this.currencyText
    //   }`;
    // },
    proceedToHotel(id) {
      const query = this.$route.query.ids
        ? { ...this.$route.query, ids: id }
        : this.$route.query;
      this.$router.push({ path: `/hotels/${id}`, query });
    },
    calcPrice
  },
  mounted() {}
};
</script>

<style scoped>
.whs-relative-hotels {
  margin: 12px 0;
}
.is-row {
  display: flex;
  flex-wrap: wrap;
  margin: 12px -12px;
  align-items: flex-start;
}
.whs-relative-headline {
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 12px 4px;
}
.whs-relative-hotel {
  flex: 1;
  margin: 12px;
  padding-bottom: 8px;
  background-color: #fff;
  /* border: 1px solid var(--color-alt-5); */
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  border-radius: 4px;
  cursor: pointer;
  overflow: hidden;
}
.whs-relative-image-wrap {
  width: 100%;
  height: 80px;
  overflow: hidden;
}
.whs-relative-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.whs-relative-name {
  padding: 6px 18px;
  font-size: 13px;
}
.whs-relative-price {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  padding: 0 18px;
}
.whs-relative-price:after {
  content: '\f054';
  width: 14px;
  font: 900 normal normal 14px/1 'Font Awesome 5 Pro';
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: var(--color-main);
  transition: 0.3s ease-out;
}
</style>